import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components';

export enum ActionIcons {
	ColumnExpositionChooser = 'action:exposition-column-chooser',
}

@Injectable()
export class AppActionsIcons extends AppIcons {
	private readonly path = './assets/img';
	protected override namespace = 'action';
	protected icons: IIcons = {
		[ActionIcons.ColumnExpositionChooser]: `${this.path}/splitscreen_vertical_add_24dp_FILL0_wght0_GRAD0_opsz24.svg`,
	};
}
